import { Injectable } from '@angular/core';

import { HttpClient, HttpRequest } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomFontUrlValidationService {

  constructor(
    private httpClient: HttpClient
  ) { }

  async validate(url: string): Promise<string> {
    if (!url) {
      return 'VALID';
    }

    let value = url;

    // Add https:// if no protocol parameter exists
    if (value.indexOf('://') === -1 || value.indexOf('://') > 5) {
      value = 'https://' + value;
    }

    const request = new HttpRequest('HEAD', value, {
      // Add headers and options here if needed
    });

    try {
      const response: any = await lastValueFrom(this.httpClient.request(request));

      if (response.status !== 200) {
        return 'LOAD_FAILURE';
      }

      const contentType = response.headers.get('content-type');
      const validFontTypes = [
        'font/ttf',
        'font/otf',
        'font/woff',
        'font/woff2',
        'application/x-font-ttf',
        'application/x-font-otf',
        'application/font-woff',
        'application/font-woff2',
        'application/x-font-opentype'
      ];

      const contentTypeLower = contentType ? contentType.toLowerCase() : '';
      const baseContentType = contentTypeLower.split(';')[0].trim();

      if (!contentType || !validFontTypes.some(type =>
          baseContentType === type || baseContentType.startsWith(type + ';'))) {
        return 'INVALID_FONT_TYPE';
      }

      return 'VALID';
    } catch (err) {
      return 'LOAD_FAILURE';
    }
  }
}